module.exports = __webpack_public_path__ + "static/img/7.a897ea0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/5/zh/7.png
// module id = 0Avv
// module chunks = 0